<template>
  <div v-on="$listeners" class="container">
    <img v-lazy="imgCover" class="img-background" :alt="imgAlt" />
    <div class="courtain">
      <div class="tag-container">
        <b-tag
          :type="property.ad_type === 1 ? 'is-primary-green' : 'is-primary'"
          size="is-small"
          class="has-text-weight-bold is-uppercase"
        >
          {{ property.ad_label }}
        </b-tag>
        <b-tag
          v-if="isAuction"
          type="is-orange"
          size="is-small"
          class="has-text-weight-bold is-uppercase"
        >
          Remate
        </b-tag>
      </div>
      <div class="bottom">
        <div class="map">
          <vue-fontawesome icon="map-marker-alt" />
        </div>
        <div class="info">
          <div class="has-text-weight-bold">${{ formattedPrice }}</div>
          <p class="ellipsis">{{ address }},</p>
          <p class="ellipsis">{{ city }}, {{ state }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PropertyCard",

  props: {
    property: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    formattedPrice() {
      return new Intl.NumberFormat().format(this.property.price);
    },
    images() {
      return this.property.images.filter(img => {
        let urlSplit = img.split("?");
        urlSplit = urlSplit[0].split(".");
        const lastIndex = urlSplit.length - 1;
        const ext = urlSplit[lastIndex].toLowerCase();

        return ext === "jpg" || ext === "png" || ext === "jpeg";
      });
    },
    imgCover() {
      return this.property.images
        ? this.images[0]
        : "@/assets/images/house_1.jpg";
    },
    isAuction() {
      return this.property.auction === true;
    },
    address() {
      const address = this.property.address.toLowerCase();
      return address;
    },
    city() {
      const city = this.property.city.toLowerCase();
      return city;
    },
    state() {
      const state = this.property.state.toLowerCase();
      return state;
    },
    imgAlt() {
      const altText =
        this.property.ad_label +
        " " +
        this.property.address.toLowerCase() +
        ", " +
        this.property.city +
        ", " +
        this.property.state;
      return altText;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  border-radius: $radius-large;
  height: 440px;
  width: 376px;
  max-width: 100%;
  min-width: 250px;
  position: relative;
}

.img-background {
  border-radius: $radius-large;
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
}

.bottom {
  display: flex;
  border-radius: $radius-large;
  width: 100%;
  margin-top: auto;
  background: linear-gradient(to top, #6c6a6b, rgba(#6c6a6b, 0.5));
  padding: 0.5em 1.8em 1.8em 1.8em;

  .map {
    margin-right: 1em;
  }

  .info {
    width: 100%;
    text-transform: capitalize;
    p {
      width: 90%;
    }
  }
}

.tag-container {
  left: 0;
  top: 0;
  display: flex;
  justify-content: flex-start;
  padding: 1.8em;
  .tag {
    margin: 0 4px;
  }
}

.courtain {
  border-radius: $radius-large;
  display: flex;
  width: 100%;
  height: 100%;
  color: $white;
  position: absolute;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
</style>
